import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { KbFileService } from 'src/app/services/feature/myacc-popup-fileService/kbfileService.service';
import { KbMyTicketService } from 'src/app/services/feature/mytickets/kb-my-tickets.service';

@Component({
  selector: 'app-ticket-edit',
  templateUrl: './ticket-edit.component.html',
  styleUrls: ['./ticket-edit.component.scss'],
  standalone: false
})
export class TicketEditComponent {
  fileService = inject(KbFileService);
  service = inject(KbMyTicketService);
  dialogRef = inject(MatDialogRef<TicketEditComponent>);
  fileName: string = '';
  subscription = new Subscription();
  newForm = new FormGroup({
    message: new FormControl(null, { validators: Validators.required }),
    status: new FormControl('OPEN')
  });
  get formControl() {
    return this.newForm.controls;
  }
  fileSelector(event: any) {
    const files = Object.values(event.files);

    files.map((file: File) => {
      this.fileService.addFile(file);
    });
    this.fileName = this.fileService.getLastFileName();
  }
  uploadOnApi() {
    const files = new FormData();
    const file = this.fileService.getAllFiles();
    file.forEach((file) => {
      files.append('attachment', file);
    })
    this.subscription.add(this.service.editFileUploadApi(this.newForm.value, files).subscribe((x: any) => {
      this.service.isFromUpdateTicketPage = true;
      this.service.isFromUpdateTicketPageKey = x[0].success;
      this.fileService.clearAllFiles();
      this.dialogRef.close();
    }, (error) => {
      if (error) {
        this.fileService.clearAllFiles();
      }
    }))
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();

    this.fileService.clearAllFiles();
  }
}
